import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 12px;
  padding: 0 20px 40px 20px;
  text-align: center;
  position: relative;
  border: 2px solid transparent;

  &:hover {
    /* border: 2px solid #1784da; */
    /* box-shadow: 0 0 20px rgba(0, 255, 255, 0.5), inset 0 0 10px rgba(0, 255, 255, 0.2); */
  }
`;

export const Header = styled.div`
  font-size: 20px;
  font-size: 20px;
  font-weight: 200;
  padding: 0 10px;
  align-self: flex-start;
  text-transform: uppercase;
  margin-bottom: 15px;
`;

export const Body = styled.div`
  padding: 15px;
  border-radius: 8px;
  box-shadow: inset 0 0 10px #1784da55;
`;
